module.exports = __webpack_public_path__ + "img/20221020-DigitalPMK_logo_W.a0b99f14.png";